// Unpublished Work © 2021-2025 Deere & Company.

import {hasAppAccess, hasPermissions} from 'Common/utils/permission-handler';
import {hasMyJDPermissions} from 'Common/utils/jd-permission-handler';
import {setInArray} from 'Common/utils/array-handlers';
import {PRO_GOLF_LICENSE_MANAGER_2} from 'Common/constants/isg-toggles';

function isAuthorized({
    appAccess: requiredAppKey,
    myJdPermissions: requiredJdPermissions,
    migrationJdPermissions,
    permission: requiredPermission,
    requiredFeature,
    requireMyJDSession,
    toggle: requiredToggle,
    requireMigration
}, {
    appKeys: userAppKeys,
    hasMyJDSession,
    isMigrated,
    licensedFeatures,
    myJdPermissions: userJdPermissions = {},
    permissions: userPermissions,
    superUser,
    isgToggles
}) {
    const credentials = {
        permissionMap: userPermissions,
        superUser
    };

    const licenseManagerEnabled = Boolean(isgToggles?.hasOwnProperty(PRO_GOLF_LICENSE_MANAGER_2));
    const hasFeatureToggle = !requiredToggle || isgToggles?.hasOwnProperty(requiredToggle);
    const hasRequiredFeature = !requiredFeature || !licenseManagerEnabled || setInArray(licensedFeatures).includes(requiredFeature);
    const hasPermittedJDSession = !requireMyJDSession || hasMyJDSession;
    const hasPermittedJDPermissions = !isMigrated || hasMyJDPermissions(userJdPermissions, ...setInArray(requiredJdPermissions));
    const hasMigrationMyJdPermissions = !migrationJdPermissions || hasMyJDPermissions(userJdPermissions, ...setInArray(migrationJdPermissions));
    const isAccessible = isMigrated || !requiredAppKey || hasAppAccess(userAppKeys, requiredAppKey);
    const isPermitted = isMigrated || !requiredPermission || hasPermissions(credentials, requiredPermission);
    const migratedMMembershipOnly = !requireMigration || isMigrated;

    return Boolean(hasFeatureToggle && hasRequiredFeature && hasPermittedJDSession && hasPermittedJDPermissions && hasMigrationMyJdPermissions && isAccessible && isPermitted && migratedMMembershipOnly);
}

export {
    isAuthorized
};
